var exports = {
  "PT": "Markup.module__markup___OEI4a2",
  "z3": "Markup.module__bio___OEI4a2",
  "Z_": "Markup.module__mutedSpoilerContext___OEI4a2",
  "nf": "Markup.module__link___OEI4a2",
  "mG": "Markup.module__inline___OEI4a2",
  "tZ": "Markup.module__inlineFormat___OEI4a2",
  "Hy": "Markup.module__codeContainer___OEI4a2",
  "h": "Markup.module__blockquoteContainer___OEI4a2",
  "xE": "Markup.module__alert___OEI4a2",
  "CZ": "Markup.module__tableContainer___OEI4a2",
  "js": "Markup.module__latexCodeBlock___OEI4a2",
  "lB": "Markup.module__codeActions___OEI4a2",
  "vo": "Markup.module__codeActionsVisible___OEI4a2",
  "r": "Markup.module__blockquoteDivider___OEI4a2",
  "rs": "Markup.module__blockquoteContent___OEI4a2",
  "em": "Markup.module__blockquoteEmptyContent___OEI4a2",
  "tp": "Markup.module__table___OEI4a2",
  "qd": "Markup.module__tableHeader___OEI4a2",
  "xR": "Markup.module__tableCell___OEI4a2",
  "Vl": "Markup.module__alignLeft___OEI4a2",
  "Hu": "Markup.module__alignCenter___OEI4a2",
  "Wk": "Markup.module__alignRight___OEI4a2",
  "Qd": "Markup.module__alertIcon___OEI4a2",
  "Ro": "Markup.module__alertTitle___OEI4a2",
  "S9": "Markup.module__alertContent___OEI4a2",
  "FU": "Markup.module__alertNote___OEI4a2",
  "ap": "Markup.module__alertTip___OEI4a2",
  "nL": "Markup.module__alertImportant___OEI4a2",
  "vc": "Markup.module__alertWarning___OEI4a2",
  "SN": "Markup.module__alertCaution___OEI4a2",
  "lE": "Markup.module__mention___OEI4a2",
  "bG": "Markup.module__interactive___OEI4a2",
  "vE": "Markup.module__timestamp___OEI4a2",
  "CU": "Markup.module__spoilerWrapper___OEI4a2",
  "N5": "Markup.module__blockSpoilerWrapper___OEI4a2",
  "p6": "Markup.module__spoiler___OEI4a2",
  "mC": "Markup.module__blockSpoiler___OEI4a2",
  "ur": "Markup.module__spoilerContent___OEI4a2",
  "yI": "Markup.module__latexContent___OEI4a2",
  "Y4": "Markup.module__hljs___OEI4a2",
  "HQ": "Markup.module__ansiCode___OEI4a2",
  "bi": "Markup.module__ansi-code-blink___OEI4a2",
  "So": "Markup.module__error___OEI4a2",
};

module.exports = exports;
